import {
  SavingIndicator,
  SavingIndicatorStatus,
} from '../../../../../components/indicator/index';
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { IAppOnlyStore } from 'stores/AllStores';
import { PricingRequestListItem } from 'components/pricing';
import { IPricingRequest } from 'common/interfaces/pricing';

// Styles
const s = require('./PricingRequestSidebar.css');

// Component
@inject('store')
@observer
export class PricingRequestSidebar extends React.Component<IAppOnlyStore, {}> {
  constructor(props) {
    super(props);
  }

  public render() {
    return <div>{this.renderPendingPricingRequests()}</div>;
  }

  private renderPendingPricingRequests() {
    const {
      pendingPricingRequests,
      fetchedPendingPricingRequests,
      loadingPendingPricingRequests,
    } = this.props.store.leadPricing;

    if (pendingPricingRequests.length > 0) {
      return (
        <div className={s.pending}>
          {pendingPricingRequests.map((request, i) => {
            return (
              <PricingRequestListItem
                key={request.id}
                showLeadAndAuthorName={false}
                className={s.pendingRequest}
                onClick={this.handlePendingPricingRequestClick}
                request={{
                  id: request.id,
                  createdByUser: request.createdByUser,
                  createdByUserId: request.createdByUserId,
                  note: request.note,
                  complete: request.complete ? 1 : 0,
                  createdAt: request.createdAt,
                  updatedAt: request.updatedAt,
                  providerId: request.providerId,
                  provider: {
                    databaseId: request.provider.id,
                    providerId: parseInt(request.provider.providerId, 10),
                    dba: request.provider.dba,
                    legalBusName: request.provider.legalBusName,
                    groupId:
                      typeof request.providerGroup !== 'undefined' &&
                      request.providerGroup !== null &&
                      typeof request.providerGroup.id !== 'undefined'
                        ? request.providerGroup.id
                        : null,
                    providerGroup:
                      typeof request.providerGroup &&
                      request.providerGroup !== null
                        ? request.providerGroup
                        : null,
                  },
                }}
              />
            );
          })}
          ;
        </div>
      );
    } else if (loadingPendingPricingRequests) {
      return (
        <div className={s.loadingContainer}>
          <SavingIndicator
            align="left"
            labels={{ saving: 'Loading pending requests...' }}
            status={SavingIndicatorStatus.Saving}
          />
        </div>
      );
    } else {
      return (
        <p key="empty-message" className={s.empty}>
          No pending pricing requests
        </p>
      );
    }
  }

  private handlePendingPricingRequestClick = (request: IPricingRequest) => {
    this.props.store.pricingRequest.fetchSinglePricingRequest(request.id);
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/PricingRequest/Sidebar/PricingRequestSidebar.tsx